import React, { useState } from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";

export default function PalletTypeModal({ onClose, onSave, initialName = "", isEditing = false }) {
  const [name, setName] = useState(initialName);

  const handleSave = () => {
    if (name.trim()) {
      onSave(name);
      onClose();
    }
  };

  const handleClose = () => {
    setName("");
    onClose();
  };

  const handleKeyPress = e => {
    if (e.key === "Enter" && name.trim()) {
      handleSave();
    }
  };

  return (
    <Dialog open onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        <Typography
          fontSize={22}
          fontWeight={500}
          color="text.primary"
          align="center"
          sx={{ flex: 1 }}
        >
          {isEditing ? "Edit Pallet Type" : "Add Pallet Type"}
        </Typography>
        <IconButton onClick={handleClose} sx={{ position: "absolute", right: 8, top: 8 }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          margin="dense"
          label="Name"
          fullWidth
          variant="outlined"
          value={name}
          onChange={e => setName(e.target.value)}
          onKeyPress={handleKeyPress}
          placeholder="Enter name"
          disabled={isEditing}
          helperText={isEditing ? "Name cannot be changed after creation." : ""}
        />
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 2 }}>
        <Button onClick={handleClose} variant="outlined">
          Cancel
        </Button>
        <Button onClick={handleSave} variant="contained" disabled={!name.trim() || isEditing}>
          Save
        </Button>
      </DialogActions>
    </Dialog>
  );
}
